import React, { Children } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isFunction from 'lodash/isFunction';

// FORM COMPONENTS
import Col from 'core/form/parts/Col';
import Label from 'core/form/parts/Label';
import Row from 'core/form/parts/Row';

//STYLES
import styles from '../table.module.scss';

// MAIN COMPONENT
const TableHeader = ({
  children,
  buttons = [],
  allowDelete,
}) => (
  <div className={styles.header}>
    <Row>
      <Label
        className={styles.label}
        col={{
          className: styles.numberCol
        }}
      >#</Label>
      <Col>
        <Row>
          {Children.map(isFunction(children) ? children() : children, (child, c) => !child?.props.label && !child?.props.colWidth ? null : (
            <Label
              key={c}
              className={styles.label}
              col={{
                className: styles.labelCol
              }}
              cols={{
                lg: child.props.colWidth
              }}
            >{child.props.label}</Label>
          ))}
        </Row>
      </Col>
      <Col
        className={clsx(
          styles.buttonCol,
          styles[`buttonCol-${buttons.length + (allowDelete ? 1 : 0)}`]
        )}
      />
    </Row>
  </div>
)

// EXPORT
export default TableHeader
